import dayjs from 'dayjs';

import { REQUEST_DETAILS_DATE_FORMAT } from 'constants/dateTime';

export const formatDate = (
  date: string,
  pattern: string = REQUEST_DETAILS_DATE_FORMAT
) => (date ? dayjs(date).format(pattern) : '');
